import { Component, OnInit, ViewChild } from '@angular/core';
import { auth_server } from '../assets/conf_urls.json';
import { HttpClient } from '@angular/common/http';
import jwt_decode from 'jwt-decode';
import { HomeService } from './shared/home.service';
import { LoggerService } from "src/shared/logger/logger.service";
import { Levels } from 'src/shared/logger/levels.enum';
import { AccessAuthService } from 'src/shared/access.auth.service';
@Component({
  selector: 'app-homepage',
  templateUrl: './homepage.component.html',
  styleUrls: ['../../bootstrap/homepage/assets/css/styles.css'],
  providers: [HomeService]
})
export class HomepageComponent implements OnInit {


  //for user access
  accessToken;
  user_role;
  roleArray: Array<string> = ['admin', 'operator', 'viewer'];
  refetchingDataFlag: boolean = false;
  adminAuthorization: boolean = false;

  constructor(private http: HttpClient,
    private homeService: HomeService,
    public accessAuthService: AccessAuthService,
    private loggerService: LoggerService) {

  }
  ngOnInit(): void {
    // if (localStorage.getItem('accessToken')) {
    //   this.accessToken = jwt_decode(localStorage.getItem('accessToken'));
    //   this.user_role = this.accessToken["role"]
    //   this.adminAuthorization = this.accessToken.role === "admin" ? true : false;
    // }
    this.accessAuthService.user_info_obj_BehaviorSubject.subscribe(data => this.user_role = data?.role)
    this.accessAuthService.isAdmin.subscribe(data => this.adminAuthorization = data)
    this.homeService.getVMSStatistics().subscribe(data => {
      this.homeService.dataToBeTransmitted.next(data.data);
    }, err => {
      this.loggerService.log("HomepageComponent", err.error.message ? err.error.message : "Error while sending data", Levels.error)
    })

  }


  refetchData() {
    if (!this.refetchingDataFlag) {
      this.refetchingDataFlag = true;
      this.homeService.getVMSStatistics().subscribe(data => {
        this.homeService.dataToBeTransmitted.next(data.data);
        this.refetchingDataFlag = false;
      }, err => {
        this.loggerService.log("HomepageComponent", err.error.message ? err.error.message : "Error while sending data", Levels.error)
        this.refetchingDataFlag = false;
      })
    }
  }

}
